import React, { useState } from "react";
import axios from "axios";
import Card from "@material-ui/core/Card";
// import Table from '@material-ui/core/Table';
// import TableBody from '@material-ui/core/TableBody';
// import TableCell from '@material-ui/core/TableCell';
// import TableContainer from '@material-ui/core/TableContainer';
// import TableRow from '@material-ui/core/TableRow';
// import Paper from '@material-ui/core/Paper';
import awsConfig from "../../awsConfig";
import configurations from "../../configurations";
import Container from "@material-ui/core/Container";
import CssBaseline from "@material-ui/core/CssBaseline";
import "./style.css";
import { getTokenForAuthentication } from "./utils";
import AlertBox from "./AlertBox";

import { Auth } from "aws-amplify";

const ForgotPasswordForm = (props) => {
  const [showAlert, toggleAlert] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const isAddonSelfEnrollment = sessionStorage.getItem("addAddon");

  const handleSendVerification = (e) => {
    e.preventDefault();
    // props.setSendVerification(true)
    props.toggleLoader(true);
    // let errorMsg = 'Sorry! We could not find an active registration for ' + props.email;
    let errorMsg =
      "Email: " +
      props.email +
      " is not registered with us. Please check the email address and retry.";
    getTokenForAuthentication()
      .then((response) => {
        let token = response["headers"].authorization;
        let request = {
          cognitoUserPool: awsConfig.aws_user_pools_id,
          username: props.email,
        };

        axios
          .post(
            configurations.authenticationURL + "v1/memberportal/getuser",
            request,
            {
              headers: {
                Authorization: token,
                "x-tenant-id": Buffer.from(`NETWELL;${new Date()}`).toString('base64')
              },
            },
          )
          .then(async (resp) => {
            if(isAddonSelfEnrollment){
              await getMemberSelfDetailsByEmail(props.email)
                .then((data) => {
                  if(data.response.status === "AC"){
                    var benefits = 
                        data &&
                        data.response &&
                        data.response.benefits &&
                        data.response.benefits[0] &&
                        data.response.benefits[0].premiumPaidDate ? data.response.benefits[0] : null;
                        if (!["NWS500", "NWS1000", "NWS2000"].includes(benefits.planId)) {
                        sessionStorage.setItem("premiumPaid", benefits.premiumPaidDate);
                        Auth.forgotPassword(props.email)
                          .then((data) => {
                            console.log("send verification");
                            console.log(data);
                            props.responseData(resp.data);
                            props.toggleLoader(false);
                            props.handleSendVerification(
                              data.CodeDeliveryDetails.Destination,
                            );
                          })
                          .catch((err) => {
                            props.toggleLoader(false);
                            console.log(err);
                            setAlertMsg(err.message || errorMsg);
                            toggleAlert(true);
                          });
                        } else {
                          props.toggleLoader(false);
                          setAlertMsg("Dental add-ons are unavailable for a Dental core plan. Please speak to your health representative for assistance.");
                          toggleAlert(true);
                        }
                  } else if(data.response.status === "TE"){ 
                       props.toggleLoader(false);
                        setAlertMsg("Membership is terminated. Please speak to your health representative for assistance.");
                        toggleAlert(true);
                  } else {
                    props.toggleLoader(false);
                    setAlertMsg("Your enrollment application is still being processed. Please speak to your health representative for assistance.");
                    toggleAlert(true);
                  }
                })
               .catch((err) => {
                  props.toggleLoader(false);
                  toggleAlert(true);
                  if (err.failedApi === "getMemberSelfDetailsByEmail") {
                    setAlertMsg("Your enrollment application is still being processed. Please speak to your health representative for assistance.");
                  } else {
                    setAlertMsg("Unable to process request at the moment. Please try again later.");
                  }
                  console.log(err);
                });
            }else{

            Auth.forgotPassword(props.email)
              .then((data) => {
                console.log("send verification");
                console.log(data);
                props.responseData(resp.data);
                props.toggleLoader(false);
                props.handleSendVerification(
                  data.CodeDeliveryDetails.Destination,
                );
              })
              .catch((err) => {
                props.toggleLoader(false);
                console.log(err);
                setAlertMsg(err.message || errorMsg);
                toggleAlert(true);
              });
            }
          })
          .catch((err) => {
            toggleAlert(true);
            setAlertMsg(errorMsg);
            props.toggleLoader(false);
          });
      })
      .catch((err) => {
        toggleAlert(true);
        setAlertMsg(errorMsg);
        props.toggleLoader(false);
      });

    // Auth.forgotPassword(props.email)
    //   .then(data => {
    //     console.log('send verification')
    //     console.log(data)
    //     props.toggleLoader(false)
    //     props.handleSendVerification(data.CodeDeliveryDetails.Destination)

    //   })
    //   .catch(err => {
    //     props.toggleLoader(false);
    //     console.log(err)
    //   });
  };

  const getMemberSelfDetailsByEmail = async (email) => {
  let URLs = configurations.baseUrl + "/setupfamily/getMemberSelfDetailsByEmail/" + email;
  let data;
  try {
    data = await axios.get(URLs);
  } catch (error) {
    error.failedApi = "getMemberSelfDetailsByEmail";
    throw error;
  }

  let memberDetails = process.env.REACT_APP_AGENT_URL + "/enrollment/getViewDetails/" + data.data.response.id;
  let response;
  try {
    response = await axios.get(memberDetails);
  } catch (error) {
    error.failedApi = "getViewDetails";
    throw error;
  }

  return response.data;
}

  return (
    <div className="login">
      <CssBaseline />
      <Container maxWidth="xs">
        <Card className="login-card" style={{ marginTop: "50px" }}>
          <div className="logo">
            <img
              alt="logo"
              className="logo-custom"
              src={require("./images/netwell-logo.png")}
            />
          </div>
          <form className="main-form" onSubmit={handleSendVerification}>
            {!isAddonSelfEnrollment && <h4>Forgot your password?</h4>}
            {isAddonSelfEnrollment ? <p>
              Enter your registered email address to receive a security code.
            </p>:<p>
              Enter your Email below and we will send a message to reset your
              password.
            </p>}
            <div className="a-form-ctrl">
              <p className="">Email</p>
              <input
                className="a-input"
                type="email"
                placeholder="Email"
                name="username"
                value={props.email}
                required
                onChange={props.handleChange}
              />
            </div>
            <div>
              <button
                type="submit"
                className="a-btn"
                style={{ color: "#ffffff", backgroundColor: "#4782c4" }}
              >
                {isAddonSelfEnrollment ? `Send`:`Reset my password`}
              </button>
              {!!!isAddonSelfEnrollment && <p style={{ textAlign: "center" }}>
                <span>Go back to</span>&nbsp;
                <span
                  className="forgot-pawd"
                  onClick={() => props.gotoLoginScreen()}
                >
                  Sign In
                </span>
              </p>}
            </div>
          </form>
        </Card>
      </Container>
      <AlertBox
        showAlert={showAlert}
        alertMsg={alertMsg}
        alertTitle={"Alert"}
        closeAlert={() => {
          setAlertMsg("");
          toggleAlert(false);
        }}
      />
    </div>
  );
};

export default ForgotPasswordForm;
